import { Box, Button, Typography } from "@luce/ui";

interface InvoiceDetailFallbackProps {
  message: string;
  onRetry?: () => void;
}

export function InvoiceDetailFallback({ message, onRetry }: InvoiceDetailFallbackProps) {
  return (
    <Box className="gap-spacing-md py-spacing-xl flex flex-col items-center">
      <Typography variant="body-md" color="neutral-foreground-intermediate" align="center">
        {message}
      </Typography>
      {onRetry && <Button variant="secondary" size="md" label="Retry" onClick={onRetry} />}
    </Box>
  );
}
